

interface sharedReducerInitialState {
    isLoading: boolean;
    token: null | string;
    user: any;
    registeredData: any;
    profileModalOpen:boolean;
    notificationCount: number;
}

const initialState: sharedReducerInitialState = {
    isLoading: false,
    token: null,
    user: null,
    registeredData: null,
    profileModalOpen:false,
    notificationCount: 0,
}

export const SHARED_REDUCER_ACTIONS = {
    LOADING: 'LOADING',
    SAVE_TOKEN: 'SAVE_TOKEN',
    LOGOUT: 'LOGOUT',
    SAVE_REGISTERED_DATA: 'SAVE_REGISTERED_DATA',
    SAVE_PROFILE_MODAL_OPEN:'SAVE_PROFILE_MODAL_OPEN',
    SAVE_NOTIFICATION_COUNT: 'SAVE_NOTIFICATION_COUNT',
}

const sharedReducer = (state: any = initialState, action: any) => {
    switch (action.type) {
        case SHARED_REDUCER_ACTIONS.LOADING:
            return {
                ...state,
                isLoading: action.payload
            };
        case SHARED_REDUCER_ACTIONS.SAVE_TOKEN:
            return {
                ...state,
                token: action.payload,
            };
        case SHARED_REDUCER_ACTIONS.LOGOUT:
            return {
                ...state,
                token: null,
                isLoading: false,
                user: null,
                permissions: [],

            }
            case SHARED_REDUCER_ACTIONS.SAVE_REGISTERED_DATA: 
            return {
                ...state,
                registeredData: action.payload,
            };
            case SHARED_REDUCER_ACTIONS.SAVE_PROFILE_MODAL_OPEN: 
            return {
                ...state,
                profileModalOpen: action.payload,
            };
            case SHARED_REDUCER_ACTIONS.SAVE_NOTIFICATION_COUNT: 
            return {
                ...state,
                notificationCount: action.payload,
            };
        default:
            return state;
    }
}

export default sharedReducer;